import React from 'react';
import { currentMonthRange } from 'infrastructure/consts/current-month-range';
import ClinicalNotesLoggedTable from 'components/molecules/clinical-notes-logged';
import { ModuleType } from 'infrastructure/enums';

interface IProps {
  patientGuid: string;
}

const CallDashboardClinicalNotesTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  return (
    <div>
      <ClinicalNotesLoggedTable
        module={ModuleType.RPM}
        patientGuid={patientGuid}
        dateRange={currentMonthRange}
        showTabs
      />
    </div>
  );
};

export default CallDashboardClinicalNotesTab;
